import RequestBuilder from '@pcid/client-request-builder';
import { errorCodes } from '@pcid/utils/validation';
import noop from '@pcid/utils/noop';
import handleError from '@pcid/actions/handle-error';
import { trackEmailAlreadyExists } from '../track-analytics';

export const getEmailFieldError = ({ tags: { errorCode } }) => ({
	EMAIL_UNAVAILABLE: errorCodes.emailExists,
	EMAIL_NOT_VALID: errorCodes.invalidEmail,
	'SHAPE-429': errorCodes.shapeEmail,
})[errorCode];

const validateEmail = (email) => new RequestBuilder()
	.withData({ email })
	.post('/validate-email')
	.then(noop)
	.catch(handleError)
	.catch(trackEmailAlreadyExists)
	.catch(getEmailFieldError);

export default validateEmail;
